import { FC, lazy } from 'react';

type PartialRecord<K extends SupportedTypes | SupportedInstances, T> = Partial<Record<K, T>>;

export type SupportedBrands = 'toyota' | 'lexus';

export type SupportedInstances =
  | 'es'
  | 'fr'
  | 'ru'
  | 'pt'
  | 'de'
  | 'it'
  | 'no'
  | 'fi'
  | 'dk'
  | 'at'
  | 'ee'
  | 'am'
  | 'ge'
  | 'az';

export type SupportedTypes =
  | 'usedCarsSimulator'
  | 'newCarsSimulator'
  | 'leasingFiltersSimulator'
  | 'stockCarsSimulator';
export type AppInstancesMap = Record<
  SupportedBrands,
  PartialRecord<SupportedTypes, PartialRecord<SupportedInstances, FC | null>>
>;

export const instancesMap: AppInstancesMap = {
  toyota: {
    usedCarsSimulator: {
      es: lazy(() => import('./toyota/usedCars/es/es.container')),
      fr: lazy(() => import('./toyota/usedCars/fr/fr.container')),
      ru: lazy(() => import('./toyota/usedCars/ru/ru.container')),
      fi: lazy(() => import('./toyota/usedCars/fi/fi.container')),
      de: lazy(() => import('./toyota/usedCars/de/de.container')),
      at: lazy(() => import('./toyota/usedCars/at/at.container')),
      ee: lazy(() => import('./toyota/usedCars/ee/ee.container')),
      am: lazy(() => import('./toyota/usedCars/am/am.container')),
      ge: lazy(() => import('./toyota/usedCars/ge/ge.container')),
      az: lazy(() => import('./toyota/usedCars/az/az.container')),
    },
    newCarsSimulator: {
      es: lazy(() => import('./toyota/newCars/es/es.container')),
      fr: lazy(() => import('./toyota/newCars/fr/fr.container')),
      pt: lazy(() => import('./toyota/newCars/pt/pt.container')),
      de: lazy(() => import('./toyota/newCars/de/de.container')),
      no: lazy(() => import('./toyota/newCars/no/no.container')),
      it: lazy(() => import('./toyota/newCars/it/it.container')),
      dk: lazy(() => import('./toyota/newCars/dk/dk.container')),
      at: lazy(() => import('./toyota/newCars/at/at.container')),
      ee: lazy(() => import('./toyota/newCars/ee/ee.container')),
      am: lazy(() => import('./toyota/newCars/am/am.container')),
      ge: lazy(() => import('./toyota/newCars/ge/ge.container')),
      az: lazy(() => import('./toyota/newCars/az/az.container')),
    },
    leasingFiltersSimulator: {
      dk: lazy(() => import('./toyota/leasingFilters/dk/dk.container')),
    },
    stockCarsSimulator: {
      de: lazy(() => import('./toyota/usedCars/de/de.container')),
    },
  },
  lexus: {
    newCarsSimulator: {
      fr: lazy(() => import('./lexus/newCars/fr/fr.container')),
      es: lazy(() => import('./lexus/newCars/es/es.container')),
      it: lazy(() => import('./lexus/newCars/it/it.container')),
      de: lazy(() => import('./lexus/newCars/de/de.container')),
      ee: lazy(() => import('./lexus/newCars/ee/ee.container')),
    },
    usedCarsSimulator: {
      es: lazy(() => import('./lexus/usedCars/es/es.container')),
      fr: lazy(() => import('./lexus/usedCars/fr/fr.container')),
      de: lazy(() => import('./lexus/usedCars/de/de.container')),
      ee: lazy(() => import('./lexus/usedCars/ee/ee.container')),
    },
  },
};
